import './cart.css';
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { getDetailCart, getDetailServiceRecommandation } from '../../actions'
import CartTable from './cartTable';
import CartSummery from './cartSummery'
import cart_empty from '../../images/emptycart.png'
import { Link } from 'react-router-dom';
import RecommandedServices from './RecommandedServices'
const Cart = ({ getDetailCart, detailCart, getDetailServiceRecommandation, cartRecommandation, mobileNav }) => {
    const {loading, data: recommandationData} = cartRecommandation
    useEffect(() => {
        getDetailCart()
        getDetailServiceRecommandation()
        
    }, [getDetailCart, getDetailServiceRecommandation])
    const calculateRecommandation = () => {
        if (recommandationData.length <= 4){
            return recommandationData
        }
        else{
            if (mobileNav){
                return recommandationData
            }
            else {
                if (window.innerWidth >= 1280){
                    return recommandationData.slice(0, 5)
                }
                return recommandationData.slice(0, 4)
            }
        }
    }
    return(
        <>
        {recommandationData.length > 0 && (
            <div className="recommanded-services-outer">
                <div className="recommanded-services ui container">
                    <h1 className="recommanded-services-title">Recommanded Products</h1>
                    <RecommandedServices data={calculateRecommandation()} loading={loading} category={detailCart.cart_detail.category}/>
                </div>
            </div>
        )}
        <div className="ui container" style={{display: detailCart.cart_detail.total > 0 ? "grid" : 'block'}}>
            {detailCart.cart_detail.total > 0 ? (
                <div className="shopping-cart-container">
                    <h1 className="shopping-cart-title">Cart Detail</h1>
                    <CartTable cart={detailCart['cart']} cartDetail={detailCart['cart_detail']}/>
                    <CartSummery cart={detailCart}/>
                </div>
            ) : (
            <div className="empty-cart">
                <h1>Your Cart is Currently Empty.</h1>
                <img src={cart_empty} alt="empty_cart" width={120}/>
                <p>Your Cart is Empty Please add some items to your cart</p>
                <Link className="positive ui button" to="/">Return To Shop</Link>
            </div>
            )}
        </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        detailCart: state.detailCart,
        cartRecommandation: state.detailServiceRecommandation,
        mobileNav: state.mobileNav
    }
}
export default connect(mapStateToProps, { getDetailCart, getDetailServiceRecommandation })(Cart)